import { Theme } from "@mui/material/styles";
import { HMO } from "constants/hmo";
import { detectHmo } from "utils/hmoDetection";

interface Styles {
  [key: string]: any;
}

const isLeumit = detectHmo() === HMO.LEUMIT;

export const styles = (theme: Theme): Styles => ({
  container: {
    display: "flex",
    flexDirection: "column",
    // Fill MainPage bodyContainer; minHeight:0 keeps nested overflow scrolling reliable.
    flex: 1,
    minHeight: 0,
    height: "100%",
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    // Grow between header content and the bottom CTA; scroll when content overflows.
    flex: 1,
    minHeight: 0,
    alignItems: "flex-start",
    overflowY: "auto",
  },
  text: {
    display: "flex",
    fontSize: theme.typography.size.xs,
    lineHeight: "18px",
    margin: `${theme.spacing.spacing3} 0 ${theme.spacing.spacing2} 0`,
  },
  textBullet: {
    fontSize: theme.typography.size.md,
    fontWeight: theme.typography.fontWeightBold,
  },
  youTubeContainer: {
    display: "flex",
    width: theme.width.full,
    justifyContent: "center",
    marginTop: theme.spacing.spacing10,
  },
  iframeClassName: {
    borderRadius: theme.borders.borderRadius.lg,
    width: theme.width.full,
  },
  innerStep2Container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: theme.width.full,
    ...(isLeumit ? {
      justifyContent: "center",
      gap: theme.spacing.spacing12,
      paddingBottom: '20%',
      height: '100%',
    } : {
      justifyContent: "space-around",
      height: `calc(100% - ${theme.spacing.spacing5})`,
    }),
  },
  sandClockContainer: {
    margin: `${theme.spacing.spacing33} 0 ${theme.spacing.spacing8} 0`,
    display: "contents",
    alignItems: "center",
    '& svg path': {
      ...(isLeumit && {
        fill: theme.palette.extraColors?.alert,
      }),
    },
  },
  timerText1: {
    textAlign: "center",
    ...(isLeumit ? {
      fontWeight: 700,
      color: theme.palette.extraColors?.heading,
      marginBottom: theme.spacing.spacing4,
    } : {
      marginBottom: theme.spacing.spacing25,
    }),
  },
});
